import React from 'react';
import Header from '../../components/Header/Header';
import VolunteerData from '../../components/VolunteerData/VolunteerData';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <VolunteerData></VolunteerData>
        </div>
    );
};

export default Home;